import React, { Component } from "react";
import { connect } from "react-redux";
import { serverResponse } from "../util/fakeServer";
import ReactGA from "react-ga";
// import { gaEventLabel } from '../settings/gaConfig';
import { Helmet } from "react-helmet";
import { getValue } from "../helper/utility";
import { setValueCookie } from "../redux/cookie/action";
import CustomCarouselWrapper from "../components/leaflet/CustomCarouselWrapper";

class Leaflet extends Component {
  state = {
    leaflet: {},
    setPageIndex: null,
    item_id: null,
    meta_tags: <Helmet></Helmet>
  };

  componentDidMount() {
    this.props.setValueCookie();
    if (serverResponse.config.ga_active) {
      ReactGA.pageview(
        `/${serverResponse.config.client_id}-${serverResponse.leaflet.id}/volantino`
      );
    }
  }

  componentWillMount() {
    let go_to_page = this.props.match.params.index;
    let item_id_get = 0;
    if (this.props.match.path === "/volantino") {
      go_to_page = 0;
    } else {
      go_to_page = this.props.match.params.index;

      if (this.props.match.params.item_id) {
        let product = "prova";
        item_id_get = this.props.match.params.item_id;
        this.setState({ item_id: this.props.match.params.item_id });
        let pages = serverResponse.leaflet.pages.filter((page) => {
          return (
            page.interactivities.filter((prod) => {
              if (prod.skul === item_id_get) {
                this.setState({
                  item_id: prod.item_id
                });
                product = prod;
                return true;
              }
              return false;
            }).length > 0
          );
        });
        if (pages.length > 0) {
          // let product = pages[0].interactivities.filter(
          //   (prod) => prod.item_id === item_id_get
          // )[0];
          // let product = serverResponse.interactivities[item_id_get];
          go_to_page = pages[0].number;

          // setTimeout(() => {
          //   let plus_btn = document.querySelector(`#plus-${product.item_id}`);
          //   if (plus_btn) plus_btn.click();
          // }, 500);
          this.setState({
            meta_tags: (
              <Helmet>
                <meta property="og:title" content={product.description}></meta>
                <meta
                  property="og:url"
                  content={
                    serverResponse.config.shareFlyerURL +
                    "/products/" +
                    product.item_id
                  }
                ></meta>
                <meta
                  property="og:description"
                  content={serverResponse.config.shareProductSentence}
                ></meta>
                <meta
                  property="og:image"
                  content={"" /*product.images[0].image_file*/}
                ></meta>
                <meta property="og:type" content="website"></meta>
              </Helmet>
            )
          });
        }
      }
    }
    // this.setState({ setPageIndex: this.props.match.params.index })

    this.setState({ setPageIndex: getValue(go_to_page) });
    // this.setState({ item_id: item_id_get });
  }

  render() {
    let tmp = Object.assign({}, serverResponse);

    const { setPageIndex } = this.state;

    const { item_id } = this.state;

    /* {this.state.meta_tags}
        <CustomCarousel
          leaflet={tmp.leaflet}
          setPageIndex={setPageIndex}
          itemId={item_id}
        />
        {serverResponse.config.adsense && <Adsense />} */

    return (
      <CustomCarouselWrapper
        leaflet={tmp.leaflet}
        setPageIndex={setPageIndex}
        itemId={item_id}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    ...state.themeChanger,
    LanguageSwitcher: state.LanguageSwitcher,
    locale: state.LanguageSwitcher.language.locale,
    authData: {
      token: state.auth.accessToken,
      isLogin: state.auth.isLogin
    },
    themeSetting: {
      toolbarAlignValue: state.themeSetting.toolbarAlignValue,
      footerAlignValue: state.themeSetting.footerAlignValue,
      sidebarDisplayValue: state.themeSetting.sidebarDisplayValue,
      toolbarDisplayValue: state.themeSetting.toolbarDisplayValue,
      footerDisplayValue: state.themeSetting.footerDisplayValue,
      sidebarTransParentValue: state.themeSetting.sidebarTransParentValue,
      transparentImage: state.themeSetting.transparentImage,
      activeLinkStyle: state.themeSetting.activeLinkStyle,
      sidebarMiniValue: state.themeSetting.sidebarMiniValue,
      sidebarTransParentActiveBack:
        state.themeSetting.sidebarTransParentActiveBack,
      sidebarTransParentActiveColor:
        state.themeSetting.sidebarTransParentActiveColor
    }
  };
};

export default connect(mapStateToProps, { setValueCookie })(Leaflet);
